export function Select({ label, options = [], placeholder, className = '', ...props }) {
  return (
    <label className="block">
      {label && <span className="block mb-1 text-sm font-medium text-slate-600 dark:text-slate-300">{label}</span>}
      <select
        className={`w-full px-3 py-2 rounded-lg border border-slate-300 dark:border-white/15 bg-white dark:bg-slate-800 text-slate-800 dark:text-slate-100 focus:outline-none focus:ring-2 focus:ring-brand/40 ${className}`}
        {...props}
      >
        {placeholder !== undefined && <option value="">{placeholder}</option>}
        {options.map((o) => {
          const value = typeof o === 'string' ? o : o.value;
          const label2 = typeof o === 'string' ? o : o.label;
          return <option key={value} value={value}>{label2}</option>;
        })}
      </select>
    </label>
  );
}
